import { createSelector } from 'reselect';

import * as types from '../actions/actionTypes';
import { updateDesignerEntityCache, updateEntityCache } from '../helper/entityReducer';
import { getCurrentPatternId, getPatterns } from './currentPattern';


export default (state, action) => {
    switch (action.type) {

        case types.PATTERNS_RECEIVED:
            return Object.assign({}, state,
                updateDesignerEntityCache(state, action),
            );

        case types.DESIGNERINFO_REQUESTED:
            return Object.assign({}, state,
                { isFetching: true },
            );

        case types.DESIGNERINFO_RECEIVED:
            return Object.assign({}, state,
                updateEntityCache(state, action, 'designer'),
            );

        default:
            return state;
    }
};


const getDesignerData = state => state.stolo.entities.designer;
export const getDesigners = state => state.stolo.entities.designer.entities;

export const getCurrentPatternDesignerName = createSelector(
    [getPatterns, getCurrentPatternId, getDesignerData],
    (patterns, patternid, designer) => {
        const pattern = patterns[patternid] || {};
        if (pattern.designer) {
            return (((designer || {}).entities || {})[pattern.designer] || {}).name ||
                null;
        }
        return null;
    },
);

export const getCurrentPatternDesigner = createSelector(
    [getPatterns, getCurrentPatternId, getDesignerData],
    (patterns, patternid, designer) => {
        const pattern = patterns[patternid] || {};
        if (pattern.designer) {
            return ((designer || {}).entities || {})[pattern.designer] || {};
        }
        return null;
    },
);

export const getCurrentRouteDesignerId = state => state.location.payload.designerid;

export const getCurrentRouteDesigner = createSelector(
    [getCurrentRouteDesignerId, getDesignerData],
    (designerid, designer) => ((designer || {}).entities || {})[designerid] || {},
);

export const hasCurrentRouteDesigner = createSelector(
    [getCurrentRouteDesignerId, getDesignerData],
    (designerid, designer) => (((designer || {}).entities || {}).designerid ||
        {}).profileImage || false,
);



// WEBPACK FOOTER //
// ./src/reducers/designer.js